<div class="trend-chart__container">
  <app-score-trending-chart
    [companyName]="companyName"
    [scoreType]="score"
    [timeperiod]="timeframe"
  >
  </app-score-trending-chart>
</div>
